import { render, staticRenderFns } from "./BtnNaoAtesto.vue?vue&type=template&id=65041c3b"
import script from "./BtnNaoAtesto.vue?vue&type=script&lang=js"
export * from "./BtnNaoAtesto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports